export const environment = {
  production: false,
  apiBaseUrl: 'https://dev-apihr.digimaster.id/api'
};
